module.exports = __webpack_public_path__ + "static/media/Antique-elegant-dress-422029-min.92d358a7.jpg";